import { BaseApiParams as BP } from '@/typings/common'


export abstract class State<T, TT = T> {
  public list?: TT[] = void 0;

  public listMeta: BP = {};

  public filters: BP = {};

  public single?: T = void 0;
}
